export default "__VITE_ASSET__ca633751__"